import { Flex, Form, Select } from '@duxton-web/ui';
import { colorContentDim } from '@duxton-web/design-tokens/themes/light';
import React from 'react';

import {
  DYNAMIC_ATTRIBUTES_VALUE_TO_LABEL_MAP,
  DYNAMIC_ATTRIBUTES_VALUES,
  MAX_SELECTED_DYNAMIC_ATTRIBUTES_COUNT,
  SMART_CAMPAIGN_FORM_KEYS,
} from 'omega-rtc/constants/ucd';
import { getAdditionalInfoOfDynamicAttributes } from 'omega-rtc/utils/smart-campaign-utils';

// Dynamic attributes selector dropdown options
const dynamicAttributesOptions = Object.values(DYNAMIC_ATTRIBUTES_VALUES).map(
  (value) => ({ label: DYNAMIC_ATTRIBUTES_VALUE_TO_LABEL_MAP[value], value }),
);

const DynamicAttributesSelector = ({ hasDynamicAttributes }) => (
  <Form.Item
    label="Dynamic attributes"
    name={SMART_CAMPAIGN_FORM_KEYS.DYNAMIC_ATTRIBUTE}
    style={{ marginBottom: hasDynamicAttributes ? '8px' : '16px' }}
  >
    <Select
      mode="multiple"
      options={dynamicAttributesOptions}
      placeholder="Select attributes"
      maxCount={MAX_SELECTED_DYNAMIC_ATTRIBUTES_COUNT}
      showSearch={false}
      optionRender={(option) => (
        <Flex vertical>
          {option.label}
          <span
            style={{
              fontSize: 12,
              color: colorContentDim,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {
              getAdditionalInfoOfDynamicAttributes(
                DYNAMIC_ATTRIBUTES_VALUE_TO_LABEL_MAP[option.value],
              ).content
            }
          </span>
        </Flex>
      )}
    />
  </Form.Item>
);

export default DynamicAttributesSelector;
